import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MembershipPackage.css';

// 协议内容
const AGREEMENT_CONTENT = `成都益美美佳网络科技有限公司订阅支付业务协议
协议前言

本协议由成都益美美佳网络科技有限公司（以下简称“公司”）与使用公司订阅制家政会员网平台服务的用户（以下简称“用户”）共同订立。本协议旨在明确双方在订阅支付业务中的权利、义务及业务流程，包括签约流程和退订流程。请用户在签署前仔细阅读本协议的全部内容。

第一条 定义与解释

1.1 订阅服务：指公司提供的家政会员网平台服务，用户通过支付订阅费用获得一定期限内的服务使用权。
1.2 签约：指用户同意本协议并完成订阅支付的过程。
1.3 退订：指用户终止订阅服务并停止支付订阅费用的过程。

第二条 签约流程

2.1 用户访问公司家政会员网平台，浏览服务内容及订阅选项。
2.2 用户选择订阅套餐，包括服务类型、期限及价格，并确认订阅意愿。
2.3 用户同意本协议条款，点击“同意并订阅”按钮。
2.4 用户提供必要的支付信息，并完成支付操作。支付方式包括但不限于银行卡支付、第三方支付平台支付等。
2.5 支付成功后，系统自动生成电子订阅凭证，用户可通过平台账户查看订阅状态及服务期限。

第三条 订阅支付条款

3.1 订阅费用：用户需按所选套餐支付订阅费用，费用标准以平台展示为准。
3.2 支付周期：订阅费用按所选周期（如月付、季付、年付）自动扣款，扣款日期为订阅生效日或续订日。
3.3 支付方式：用户需确保支付信息准确有效，因信息错误导致的支付失败由用户承担责任。
3.4 费用调整：公司保留根据市场情况调整订阅费用的权利，调整前将通过平台公告或邮件通知用户。

第四条 退订业务流程

4.1 退订申请：用户可在订阅期限内通过平台账户提交退订申请。申请需明确退订原因及终止日期。
4.2 退订处理：公司收到退订申请后，将在3个工作日内审核并处理。审核通过后，订阅服务将在终止日期停止，后续费用不再扣款。
4.3 退款政策：
- 若退订发生在订阅周期开始前，用户可获全额退款。
- 若退订发生在订阅周期内，用户可获剩余未使用服务时间的按比例退款，具体计算方式为：剩余天数总天数 × 订阅费用。
- 退款将在退订处理完成后7个工作日内原路返回至支付账户。
4.4 特殊情况：若用户因公司服务违约（如服务中断、质量不达标）提出退订，公司将在核实后立即处理退订及退款，并承担相应违约责任。

第五条 双方权利义务

5.1 公司义务：
- 提供稳定、安全的家政会员网平台服务。
- 及时处理用户退订申请及退款。
- 保护用户隐私及支付信息安全。
5.2 用户义务：
- 按时支付订阅费用。
- 遵守平台使用规则，不进行违规操作。
- 提供真实有效的支付信息。

第六条 违约责任

6.1 若公司未按约定提供服务或处理退订，用户有权要求赔偿损失，包括但不限于订阅费用及合理维权费用。
6.2 若用户未按时支付费用或提供虚假信息，公司有权暂停服务直至问题解决，并保留追究法律责任的权利。

第七条 协议变更与终止

7.1 公司可更新本协议，更新内容将通过平台公告或邮件通知用户。用户继续使用服务即视为接受更新。
7.2 本协议在用户退订或公司终止服务时自动终止。

第八条 争议解决

8.1 双方应通过友好协商解决争议。协商不成，可向公司所在地人民法院提起诉讼。

第九条 其他条款

9.1 本协议自用户完成签约支付之日起生效。
9.2 本协议一式两份，双方各执一份，具有同等法律效力。`;

const MembershipPackage = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState(0); // 0: 选择权益包, 1: 填写基本信息, 2: 填写身份信息
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [showAgreementModal, setShowAgreementModal] = useState(false);
    const [formData, setFormData] = useState({
        phone: '',
        bank: '',
        name: '',
        idCard: ''
    });

    // 权益包配置 - 优化数据结构
    const packages = [
        {
            id: 1,
            name: '基础月卡',
            price: '29.9',
            originalPrice: '39.9',
            tag: '入门首选',
            discount: '全场 9 折',
            rights: [
                '爱奇艺/优酷/腾讯/芒果 (任选1)',
            ],
            gradient: 'linear-gradient(135deg, #e0f7fa 0%, #80deea 100%)',
            accent: '#0097a7'
        },
        {
            id: 2,
            name: '标准月卡',
            price: '59.9',
            originalPrice: '79.9',
            tag: '超值推荐',
            discount: '全场 8 折',
            rights: [
                '爱奇艺/优酷/腾讯/芒果 (任选2)',
            ],
            gradient: 'linear-gradient(135deg, #e3f2fd 0%, #90caf9 100%)',
            accent: '#1976d2'
        },
        {
            id: 3,
            name: '高级月卡',
            price: '99.9',
            originalPrice: '129.9',
            tag: '出行无忧',
            discount: '全场 7 折',
            rights: [
                '爱奇艺/优酷/腾讯/芒果 (任选2)',
                '高德/滴滴/美团/饿了么红包 (满30减15)'
            ],
            gradient: 'linear-gradient(135deg, #f3e5f5 0%, #ce93d8 100%)',
            accent: '#7b1fa2'
        },
        {
            id: 4,
            name: '至尊月卡',
            price: '199',
            originalPrice: '259',
            tag: '尊享全能',
            discount: '全场 6 折',
            rights: [
                '爱奇艺/优酷/腾讯/芒果 (任选3)',
                '高德/滴滴/美团/饿了么红包 (满30减15)',
                '每日外卖券5元 (天天领取)'
            ],
            gradient: 'linear-gradient(135deg, #ffebee 0%, #ef9a9a 100%)',
            accent: '#d32f2f'
        }
    ];

    const banks = [
        '中国工商银行', '中国建设银行', '中国农业银行', '中国银行',
        '招商银行', '交通银行', '中信银行', '浦发银行'
    ];

    // 表单处理
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // 自动带入姓名
    const handleNameAutoFill = () => {
        if (formData.phone) {
            setFormData(prev => ({ ...prev, name: `用户${prev.phone.slice(-4)}` }));
        }
    };

    // 步骤1提交
    const handleStep1Submit = (e) => {
        e.preventDefault();
        const phoneReg = /^1[3-9]\d{9}$/;
        if (!phoneReg.test(formData.phone)) {
            alert('请输入正确的手机号码！');
            return;
        }
        if (!formData.bank) {
            alert('请选择开户银行！');
            return;
        }
        handleNameAutoFill(); // 进入下一步前自动填入姓名（模拟）
        setStep(2);
    };

    // 步骤2提交
    const handleStep2Submit = (e) => {
        e.preventDefault();
        const idCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!formData.name) {
            alert('请输入姓名！');
            return;
        }
        if (!idCardReg.test(formData.idCard)) {
            alert('请输入正确的身份证号码！');
            return;
        }

        // 创建新订单对象
        const newOrder = {
            id: Date.now(),
            serviceName: `联合会员 - ${selectedPackage.name}`,
            serviceTime: `生效中 (自动续费)`,
            price: selectedPackage.price,
            status: '已生效',
            address: '线上权益',
            createTime: new Date().toLocaleString('zh-CN'),
            completeTime: '—',
            isMembership: true,
            rights: selectedPackage.rights // 存储权益信息
        };

        // 获取现有订单并添加新订单
        try {
            const storedOrders = localStorage.getItem('housekeeping_orders');
            let orders = storedOrders ? JSON.parse(storedOrders) : [];
            // 将新订单添加到开头
            orders = [newOrder, ...orders];
            localStorage.setItem('housekeeping_orders', JSON.stringify(orders));
        } catch (error) {
            console.error('保存订单失败', error);
        }
        
        // 提交成功，模拟购买成功
        alert(`签约成功！\n您已开通 ${selectedPackage.name}\n首月扣款：¥${selectedPackage.price}\n后续将每月自动续费`);
        navigate('/my'); // 返回我的页面
    };

    // 渲染权益包选择列表
    const renderPackageSelection = () => (
        <div className="packages-grid">
            {packages.map(pkg => (
                <div 
                    key={pkg.id} 
                    className={`package-card-new ${selectedPackage?.id === pkg.id ? 'selected' : ''}`}
                    onClick={() => setSelectedPackage(pkg)}
                >
                    <div className="card-bg" style={{background: pkg.gradient}}></div>
                    <div className="card-tag" style={{background: pkg.accent}}>{pkg.tag}</div>
                    
                    <div className="card-header">
                        <h3 style={{color: pkg.accent}}>{pkg.name}</h3>
                        <div className="price-block">
                            <span className="currency">¥</span>
                            <span className="amount">{pkg.price}</span>
                            <span className="period">/月</span>
                        </div>
                        <div className="original-price">原价 ¥{pkg.originalPrice}</div>
                    </div>

                    <div className="card-divider"></div>

                    <div className="card-benefits">
                        <div className="benefit-row primary">
                            <span className="icon-circle" style={{background: pkg.accent}}>✓</span>
                            <span className="text">{pkg.discount}</span>
                        </div>
                        {pkg.rights.map((right, idx) => (
                            <div key={idx} className="benefit-row">
                                <span className="icon-dot" style={{background: pkg.accent}}></span>
                                <span className="text">{right}</span>
                            </div>
                        ))}
                    </div>

                    <div className="card-action">
                        {selectedPackage?.id === pkg.id ? (
                           <span className="selected-mark" style={{color: pkg.accent}}>
                               <span className="check-icon">✓</span> 已选择
                           </span>
                        ) : (
                           <span className="click-tip">点击查看详情</span> 
                        )}
                    </div>
                </div>
            ))}
            
            <div className="bottom-bar-placeholder"></div>
            
            {/* 底部悬浮确认栏 */}
            {selectedPackage && (
                <div className="fixed-bottom-bar">
                    <div className="bar-info">
                        <span className="bar-label">已选：</span>
                        <div className="bar-details">
                            <span className="bar-name">{selectedPackage.name}</span>
                            <span className="bar-price">¥{selectedPackage.price}<small>/月</small></span>
                        </div>
                    </div>
                    <button 
                        className="btn-confirm" 
                        onClick={() => setStep(1)}
                        style={{background: selectedPackage.accent}}
                    >
                        立即签约
                    </button>
                </div>
            )}
        </div>
    );

    // 渲染购买表单
    const renderBuyForm = () => (
        <div className="form-wrapper">
             <div className="package-summary" style={{background: selectedPackage.gradient}}>
                <div className="summary-left">
                    <h4>{selectedPackage.name}</h4>
                    <p>自动续费 · 随时可关</p>
                </div>
                <div className="summary-right">
                    <span className="price">¥{selectedPackage.price}<small>/月</small></span>
                </div>
                <button className="btn-change-text" onClick={() => setStep(0)}>更换</button>
            </div>

            <div className="step-indicator">
                <div className={`step-dot ${step >= 1 ? 'active' : ''}`}>1</div>
                <div className="step-line"></div>
                <div className={`step-dot ${step >= 2 ? 'active' : ''}`}>2</div>
            </div>
            <div className="step-labels">
                <span>基本信息</span>
                <span>身份认证</span>
            </div>

            <div className="form-card">
            {step === 1 && (
                <form className="clean-form" onSubmit={handleStep1Submit}>
                    <h3 className="form-title">完善基本信息</h3>
                    <div className="input-group">
                        <label>手机号码</label>
                        <input 
                            type="tel" 
                            name="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            placeholder="请输入11位手机号码"
                            maxLength="11"
                        />
                    </div>
                    <div className="input-group">
                        <label>开户银行</label>
                        <div className="select-wrapper">
                            <select 
                                name="bank" 
                                value={formData.bank}
                                onChange={handleInputChange}
                            >
                                <option value="">请选择银行</option>
                                {banks.map(bank => (
                                    <option key={bank} value={bank}>{bank}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <button type="submit" className="btn-next">下一步</button>
                </form>
            )}

            {step === 2 && (
                <form className="clean-form" onSubmit={handleStep2Submit}>
                     <h3 className="form-title">实名认证</h3>
                    <div className="input-group">
                        <label>真实姓名</label>
                        <input 
                            type="text" 
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="姓名"
                        />
                    </div>
                    <div className="input-group">
                        <label>身份证号</label>
                        <input 
                            type="text" 
                            name="idCard"
                            value={formData.idCard}
                            onChange={handleInputChange}
                            placeholder="请输入身份证号码"
                            maxLength="18"
                        />
                    </div>
                    
                    <div className="agreement-check">
                        <p>点击开启即表示同意<span className="link-text" onClick={() => setShowAgreementModal(true)}>《联合会员自动续费服务协议》</span></p>
                    </div>

                    <div className="btn-row">
                        <button type="button" className="btn-outline" onClick={() => setStep(1)}>返回</button>
                        <button type="submit" className="btn-next">开启月扣服务</button>
                    </div>
                </form>
            )}
            </div>

            {/* 协议模态框 */}
            {showAgreementModal && (
                <div className="modal-overlay" onClick={() => setShowAgreementModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>联合会员自动续费服务协议</h3>
                            <button className="modal-close" onClick={() => setShowAgreementModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                {AGREEMENT_CONTENT}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn-confirm" 
                                    onClick={() => setShowAgreementModal(false)} 
                                    style={{width: '100%', background: '#333', marginTop: 0}}>
                                我已阅读并同意
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <div className="membership-page-new">
            <header className={`page-header-clean ${step === 0 ? 'transparent' : ''}`}>
                <button className="back-icon" onClick={() => navigate(-1)}>
                    <svg viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>
                </button>
                <h1>会员权益中心</h1>
            </header>
            <div className="content-scroll">
                {step === 0 ? (
                    <>
                        <div className="page-intro">
                            <div className="intro-badge">Exclusive Access</div>
                            <h2>升级您的生活方式</h2>
                            <p>开通月卡，享受超值专属特权</p>
                        </div>
                        {renderPackageSelection()}
                    </>
                ) : renderBuyForm()}
            </div>
        </div>
    );
};

export default MembershipPackage;
